import { Injectable } from '@angular/core';
import { ThemeserviceService } from './themeservice.service';

@Injectable({
  providedIn: 'root'
})
export class SetThemeService {

  constructor(private readonly themeService:ThemeserviceService ) { }
 
  applyTheme(tenant_id:any) : void {
    const folder_id = `tenant-${tenant_id}`;
    this.themeService.loadClientStylesheet(folder_id);
  }
}
